<template>
  <thead>
    <tr>
      <th class="is-unselectable"
        v-for="column in columnMeta.items"
        :key="column.fieldId"
        :class="{ 'has-cursor-pointer': column.label && !column.disableOrdering, 'is-active': isColumnActive(column, filter), 'has-text-right': hasTextRight(column) }"
        v-on="!column.disableOrdering ? { click: () => setOrder(column) } : {}">

        <template v-if="column.label">
          <div class="is-flex">
            <div style="flex: 1">{{ column.label }}</div>
            <div style="flex: 0 0 1rem; text-align: right" v-if="!column.disableOrdering" class="is-pulled-right sort-by-direction">{{ sortByIcon(column, filter) }}</div>
          </div>
        </template>

      </th>
      <th v-if="columnMeta.hasActions || showContextMenu"></th>
      <!-- <th v-if="columnMeta.hasActions">{{ columnMeta.hasActions }}</th>
      <th v-if="showContextMenu">{{ showContextMenu }}</th> -->
    </tr>
  </thead>
</template>

<script>
export default {
  props: {
    columnMeta: Object,
    filter: Object,
    showContextMenu: Boolean
  },
  methods: {
    setOrder (column) {
      if (this.filter.orderByColumn === column.fieldId) {
        this.filter.orderByDescending = !this.filter.orderByDescending
      } else {
        this.filter.orderByColumn = column.fieldId
        this.filter.orderByDescending = false
      }
    },
    sortByIcon (column, filter) {
      if (column.fieldId === filter.orderByColumn) {
        if (filter.orderByDescending) {
          return '↑'
        }
        return '↓'
      }
    },
    isColumnActive (column, filter) {
      return this.filter.orderByColumn === column.fieldId
    },
    hasTextRight (column) {
      switch (column.dataType) {
        case 'number':
        case 'currency':
          return true
        default:
          return false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/table/AgileTableHead.vue